import { createAction, handleActions } from 'redux-actions';
import { _getCologneList, _deleteCologne, _addCologne, _editCologne, _bulkUpdateCologne } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';
import { _getCologneListByPagination } from '../../../shared/httpService/apis';

const initialState = {
  cologne_list: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },
  add_cologne: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  edit_cologne: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  update_cologne: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  delete_cologne: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  colognelist_paginated: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  }
};
//COLOGNE LIST
export const getCologneListStart = createAction(ActionTypes.GET_COLOGNE_LIST);
export const getCologneListSuccess = createAction(ActionTypes.GET_COLOGNE_LIST_SUCCESS, response => response);
export const getCologneListError = createAction(ActionTypes.GET_COLOGNE_LIST_ERROR, error => error);

export const getCologneList = (page = '', pageSize, searchQuery) => (dispatch) => {
  dispatch(getCologneListStart());
  return _getCologneList(page, pageSize, searchQuery).then((response) => {
    dispatch(getCologneListSuccess(response));
  }).catch((error) => {
    dispatch(getCologneListError(error));
  });
};

//ADD COLOGNE
export const addCologneStart = createAction(ActionTypes.ADD_COLOGNE);
export const addCologneSuccess = createAction(ActionTypes.ADD_COLOGNE_SUCCESS, response => response);
export const addCologneError = createAction(ActionTypes.ADD_COLOGNE_ERROR, error => error);

export const addCologne = (data) => (dispatch) => {
  dispatch(addCologneStart());
  return _addCologne(data).then((response) => {
    dispatch(addCologneSuccess(response));
  }).catch((error) => {
    dispatch(addCologneError(error));
  });
};

//EDIT COLOGNE
export const editCologneStart = createAction(ActionTypes.EDIT_COLOGNE);
export const editCologneSuccess = createAction(ActionTypes.EDIT_COLOGNE_SUCCESS, response => response);
export const editCologneError = createAction(ActionTypes.EDIT_COLOGNE_ERROR, error => error);

export const editCologne = (id, data) => (dispatch) => {
  dispatch(editCologneStart());
  return _editCologne(id, data).then((response) => {
    dispatch(editCologneSuccess(response));
  }).catch((error) => {
    dispatch(editCologneError(error));
  });
};
//BULK UPDATE COLOGNE

export const bulkUpdateCologneStart = createAction(ActionTypes.BULK_UPDATE_COLOGNE);
export const bulkUpdateCologneSuccess = createAction(ActionTypes.BULK_UPDATE_COLOGNE_SUCCESS, response => response);
export const bulkUpdateCologneError = createAction(ActionTypes.BULK_UPDATE_COLOGNE_ERROR, error => error);

export const bulkUpdateCologne = (data) => (dispatch) => {
  dispatch(bulkUpdateCologneStart());
  return _bulkUpdateCologne(data).then((response) => {
    dispatch(bulkUpdateCologneSuccess(response));
  }).catch((error) => {
    dispatch(bulkUpdateCologneError(error));
  });
};
//COLOGNE DELETE
export const deleteCologneStart = createAction(ActionTypes.DELETE_COLOGNE);
export const deleteCologneSuccess = createAction(ActionTypes.DELETE_COLOGNE_SUCCESS, response => response);
export const deleteCologneError = createAction(ActionTypes.DELETE_COLOGNE_ERROR, error => error);

export const deleteCologne = (id) => (dispatch) => {
  dispatch(deleteCologneStart());
  return _deleteCologne(id).then((response) => {
    dispatch(deleteCologneSuccess(response));
  }).catch((error) => {
    dispatch(deleteCologneError(error));
  });
};



export const ColognePaginatedListStart = createAction(ActionTypes.GET_COLOGNE_LIST_PAGINATED);
export const ColognePaginatedListeSuccess = createAction(ActionTypes.GET_COLOGNE_LIST_PAGINATED_SUCCESS, response => response);
export const ColognePaginatedListError = createAction(ActionTypes.GET_COLOGNE_LIST_PAGINATED_ERROR, error => error);

export const getCologneListByPagination = (pageNo, pageSize,inputValue) => (dispatch) => {
  dispatch(ColognePaginatedListStart());
  return _getCologneListByPagination(pageNo, pageSize, inputValue).then((response) => {
    dispatch(ColognePaginatedListeSuccess(response));
  }).catch((error) => {
    dispatch(ColognePaginatedListError(error));
  });
};


const reducer = handleActions({


  //COLOGNE_LIST BY PAGINATION
  [ActionTypes.GET_COLOGNE_LIST_PAGINATED]: (state) => ({
    ...state, colognelist_paginated: {
      ...state.colognelist_paginated,
      loading: true, hasError: false, error: {}
    },
    display_cologne: null
  }),
  [ActionTypes.GET_COLOGNE_LIST_PAGINATED_SUCCESS]: (state, action) => (
    {
      ...state,
      colognelist_paginated: {
        ...state.colognelist_paginated,
        response: action.payload, loading: false, hasError: false, error: {}
      },
      display_cologne: action.payload?.data?.active
    }),
  [ActionTypes.GET_COLOGNE_LIST_PAGINATED_ERROR]: (state, action) => ({
    ...state,
    colognelist_paginated: {
      ...state.colognelist_paginated,
      error: action.payload, loading: false, hasError: true, response: {}
    },
    display_cologne: null
  }),


  //COLOGNE_LIST
  [ActionTypes.GET_COLOGNE_LIST]: (state) => ({
    ...state, cologne_list: {
      ...state.cologne_list,
      loading: true, hasError: false, error: {}
    },
    display_cologne: null
  }),
  [ActionTypes.GET_COLOGNE_LIST_SUCCESS]: (state, action) => (
    {
      ...state,
      cologne_list: {
        ...state.cologne_list,
        response: action.payload, loading: false, hasError: false, error: {}
      },
      display_cologne: action.payload?.data?.active
    }),
  [ActionTypes.GET_COLOGNE_LIST_ERROR]: (state, action) => ({
    ...state,
    cologne_list: {
      ...state.cologne_list,
      error: action.payload, loading: false, hasError: true, response: {}
    },
    display_cologne: null
  }),
  //ADD_COLOGNE
  [ActionTypes.ADD_COLOGNE]: (state) => ({
    ...state,
    add_cologne: {
      ...state.add_cologne,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.ADD_COLOGNE_SUCCESS]: (state, action) => ({
    ...state,
    add_cologne: {
      ...state.add_cologne,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.ADD_COLOGNE_ERROR]: (state, action) => ({
    ...state,
    add_cologne: {
      ...state.add_cologne,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //EDIT_COLOGNE
  [ActionTypes.EDIT_COLOGNE]: (state) => ({
    ...state,
    edit_cologne: {
      ...state.edit_cologne,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.EDIT_COLOGNE_SUCCESS]: (state, action) => ({
    ...state,
    edit_cologne: {
      ...state.edit_cologne,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_COLOGNE_ERROR]: (state, action) => ({
    ...state,
    edit_cologne: {
      ...state.edit_cologne,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //BULK_UPDATE_COLOGNE
  [ActionTypes.BULK_UPDATE_COLOGNE]: (state) => ({
    ...state,
    update_cologne: {
      ...state.update_cologne,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.BULK_UPDATE_COLOGNE_SUCCESS]: (state, action) => ({
    ...state,
    update_cologne: {
      ...state.update_cologne,
      response: action.payload, loading: false, hasError: false, error: {}
    },
    display_cologne: action.payload?.data?.active
  }),
  [ActionTypes.BULK_UPDATE_COLOGNE_ERROR]: (state, action) => ({
    ...state,
    update_cologne: {
      ...state.update_cologne,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //COLOGNE DELETE
  [ActionTypes.DELETE_COLOGNE]: (state) => ({
    ...state,
    delete_cologne: {
      ...state.delete_cologne,
      loading: true, hasError: false, error: {}, response: {}
    }
  }),
  [ActionTypes.DELETE_COLOGNE_SUCCESS]: (state, action) => ({
    ...state,
    delete_cologne: {
      ...state.delete_cologne,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.DELETE_COLOGNE_ERROR]: (state, action) => ({
    ...state,
    delete_cologne: {
      ...state.delete_cologne,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
}, initialState);

export default reducer;
